/**
 * Helper del resizer de Cloudflare. Vive en el ui-kit porque lo usan la app y
 * team: la preview del arte de un CTA en team tiene que hacer exactamente la
 * misma llamada que va a hacer la app (R6.1), o deja de servir para ver el
 * recorte antes de guardar.
 */

type CdnOptions = {
  w?: number | string,
  h?: number | string,
  q?: number,
  /**
   * `cover` recorta a la caja pedida en vez de deformar. Sin esto, pedir ancho
   * *y* alto no coincide con la geometria que declara el `<img>`, que es de
   * donde sale el CLS (R8).
   */
  fit?: 'cover' | 'contain' | 'scale-down' | 'crop' | 'pad',
  /** `auto` sirve WebP a quien lo acepta y deja el original para el resto. */
  format?: 'auto' | 'webp' | 'avif' | 'json',
  trim?: { left: number, top: number, width: number, height: number }
}

export const cdn = (src: string, options?: CdnOptions) => {
  const env = (import.meta as any).env || {};

  if (env.VITE_BYPASS_CLOUDFLARE === 'true') return src;

  const quality = env.VITE_CDN_QUALITY || 70;
  const host = `https://${env.VITE_APP_ENV === 'production' ? '' : env.VITE_APP_ENV === 'staging' ? 'staging.' : 'dev.'}olagg.io`;
  const dpr = (window.devicePixelRatio || 1).toFixed(1);
  const ops = [
    `dpr=${dpr}`,
    `quality=${options?.q || quality}`,
    ...(options?.w ? [`width=${options.w}`] : []),
    ...(options?.h ? [`height=${options.h}`] : []),
    ...(options?.fit ? [`fit=${options.fit}`] : []),
    ...(options?.format ? [`format=${options.format}`] : []),
  ].join(',');
  const trim = options?.trim ? `,trim.left=${options.trim.left},trim.top=${options.trim.top},trim.width=${options.trim.width},trim.height=${options.trim.height}` : '';

  return `${host}/cdn-cgi/image/${ops}${trim}/${src}`;
};
